import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=a5579152&"
import script from "./membership.vue?vue&type=script&lang=ts&"
export * from "./membership.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "membership.vue"
export default component.exports